export default __webpack_public_path__ + "static/media/165.443f94ee.jpg";